import { computed, ref } from 'vue'

const mobileBarInView = ref<boolean>(false)
const mobileUserAboveBar = ref<boolean>(true)
const desktopIsFloating = ref<boolean>(true)

let mobileObserver: IntersectionObserver | null = null
let desktopObserver: IntersectionObserver | null = null

const DESKTOP_OFFSET_BOTTOM = 32 // bottom-8 = 2rem = 32px

function observeMobile(el: HTMLElement) {
  mobileObserver?.disconnect()
  mobileObserver = new IntersectionObserver(
    ([entry]) => {
      if (!entry) {
        return;
      }
      mobileBarInView.value = entry.isIntersecting
      mobileUserAboveBar.value = entry.boundingClientRect.top > 0
    },
    { threshold: 0 },
  )
  mobileObserver.observe(el)
}

function unobserveMobile() {
  mobileObserver?.disconnect()
  mobileObserver = null
  mobileBarInView.value = false
  mobileUserAboveBar.value = true
}

function observeDesktop(el: HTMLElement) {
  desktopObserver?.disconnect()
  desktopObserver = new IntersectionObserver(
    ([entry]) => {
      if (!entry) {
        return;
      }
      desktopIsFloating.value = entry.intersectionRatio < 1
    },
    {
      threshold: [1],
      rootMargin: `100% 0px -${DESKTOP_OFFSET_BOTTOM + 3}px 0px`,
    },
  )
  desktopObserver.observe(el)
}

function unobserveDesktop() {
  desktopObserver?.disconnect()
  desktopObserver = null
  desktopIsFloating.value = true
}

export function useStickyBarVisibility() {
  const showMobileFlupje = computed(() => !mobileBarInView.value && mobileUserAboveBar.value)

  return {
    observeMobile,
    unobserveMobile,
    observeDesktop,
    unobserveDesktop,
    showMobileFlupje,
    desktopIsFloating,
  }
}
